import { useField } from 'formik'
import { Box } from '@mui/material'
import { DateRangePickerComponent } from '@/views/components'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

const DateRangeFilterType = ({ handleChangeSearch }: Props) => {
  const [fieldStartDate] = useField('startDate')
  const [fieldEndDate] = useField('endDate')

  const onChangeStartDate = (date: Date | null) => {
    handleChangeSearch('startDate', date)
  }

  const onChangeEndDate = (date: Date | null) => {
    handleChangeSearch('endDate', date)
  }

  return (
    <Box mt="16px" ml="16px">
      <DateRangePickerComponent
        startDate={fieldStartDate.value}
        endDate={fieldEndDate.value}
        onChangeStartDate={onChangeStartDate}
        onChangeEndDate={onChangeEndDate}
      />
    </Box>
  )
}
export default DateRangeFilterType
